import { useFormikContext } from "formik";
import React, { useState, useEffect } from "react";
import _Button from "../../../generic/_Button";
import _Badge from "../../../generic/_Badge";
import _Input from "../../../generic/_Input";
import ModalAction from "../../../modal/ModalAction";
import ImageUpload from "../../ImageUpload";
import OptionLabelsSelector from "../../OptionLabelsSelector";
import { ErrorMessage, SuccessMessage } from "../../../../utils/toastify";
import Icon from "../../../Icon";
import { useAuth } from "../../../../Context/AuthContext";
import PropTypes from "prop-types";
import axios from "axios";
import useAdvanceRCS from "../../hooks/useAdvanceRcs";
import { FILES_SERVICE_URL } from "../../../../utils/ApiEndpoint";
const ImageActions = (props) => {
  const auth = useAuth();
  let { token } = auth.getSessionData();
  const { carrousel = null } = props;
  /* eslint-disable no-unused-vars */
  const { values, setFieldValue, errors, handleChange, handleBlur } =
    useFormikContext();
  const [show, setShow] = useState(false);
  const [isUpload, setIsUpload] = useState(false);
  const [previewUrl, setPreviewUrl] = useState(null);
  const [file, setFile] = useState(null);
  const [loading, setLoading] = useState(false);

  const { basePath, currentValues } = useAdvanceRCS({
    key: "imageUrl",
    carrousel: carrousel,
    values: values,
  });

  const { basePath: basePathThumbnail } = useAdvanceRCS({
    key: "thumbnail_url",
    carrousel: carrousel,
    values: values,
  });

  const getFieldErrors = () => {
    if (carrousel !== null) {
      return errors?.carrousel?.[carrousel]?.imageUrl;
    }

    return errors?.imageUrl;
  };

  useEffect(() => {
    if (isUpload && !currentValues) {
      handleCleanUpload();
    }
  }, [values.step]);
  const handleUploadImage = async () => {
    setLoading(true);
    if (!previewUrl) {
      ErrorMessage("Por favor, seleccione una imagen para subir");
      return;
    }

    const buffer = await file.arrayBuffer();
    const file_content = btoa(
      new Uint8Array(buffer).reduce(
        (data, byte) => data + String.fromCharCode(byte),
        "",
      ),
    );

    const data = {
      type_file: file.type,
      file: file_content,
      name: file.name || `file-${Date.now()}`,
    };

    try {
      const response = await axios.post(FILES_SERVICE_URL, data, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });

      if (response?.status !== 200) {
        throw new Error("Error al subir la imagen");
      }

      setFieldValue(basePath, response?.data?.data?.uri);
      setFieldValue(basePathThumbnail, response?.data?.data?.thumbnail);
      setShow(false);
      SuccessMessage("Imagen agregada con éxito");
    } catch (error) {
     ErrorMessage(`Ha ocurrido un error, fallo al subir el archivo`);
    } finally {
      setLoading(false);
    }
  };

  const _onClose = () => {
    setShow(false);
  };

  const handleCleanUpload = () => {
    setPreviewUrl(null);
    setFile(null);
    setIsUpload(!isUpload);
    setFieldValue(basePath, "");
  };

  const isDisabled = () => {
    let disabled = false;

    if (!isUpload) {
      disabled = errors && !!getFieldErrors();
    } else if (isUpload) {
      disabled = !file || !previewUrl;
    }

    return disabled;
  };

  return (
    <>
      <_Badge count={currentValues ? 1 : 0}>
        <_Button
          icon="image"
          style="none"
          className="w-full"
          title="Imagen"
          onClick={() => setShow(true)}
        />
      </_Badge>
      <ModalAction
        title="Agregar imágenes"
        onClose={() => setShow(false)}
        visible={show}
      >
        <div className="space-y-2">
          <OptionLabelsSelector
            options={[
              {
                label: "Subir imagen",
                value: true,
              },
              {
                label: "Agregar URL",
                value: false,
              },
            ]}
            value={isUpload}
            onChange={handleCleanUpload}
          />

          {isUpload ? (
            <ImageUpload
              previewUrl={previewUrl}
              setPreviewUrl={setPreviewUrl}
              file={file}
              setFile={setFile}
            />
          ) : (
            <>
              <_Input
                title="Añadir URL de la imagen"
                name="imageUrl"
                id="imageUrl"
                type="text"
                value={currentValues}
                onChange={(e) => {
                  setFieldValue(basePath, e.target.value);
                }}
                onBlur={handleBlur}
                isError={!!getFieldErrors()}
                errors={getFieldErrors()}
                required
              />

              {!currentValues || (errors && !!getFieldErrors()) ? (
                <div className="flex flex-col items-center justify-center rounded-lg border-2 border-gray-300 border-dashed border-border p-8 text-center max-h-[300px]">
                  <Icon icon="image" />
                  <span className="text-gray-600">Preview de la imagen </span>
                </div>
              ) : (
                <img
                  src={currentValues}
                  alt="Preview"
                  className="h-auto w-full rounded-md object-contain"
                  style={{ maxHeight: "300px" }}
                  onError={(e) => {
                    e.target.src =
                      "https://d1x6nshzzr4pih.cloudfront.net/files/images/308a5bb3-fc10-4963-ab68-c0d19d4cb5fb.jpg";
                  }}
                />
              )}

              <div className="flex justify-end">
                <_Button
                  style="none"
                  title="Limpiar"
                  icon="clear"
                  onClick={() => {
                    setFieldValue(basePath, "");
                  }}
                />
              </div>
            </>
          )}
        </div>
        <div className="p-3 bg-white">
          <div className="mt-3 flex justify-end gap-2 pt-3">
            <_Button
              title="Cancelar"
              style="none"
              type="button"
              onClick={_onClose}
              loading={loading}
            />
            <_Button
              style="primary"
              title="Guardar"
              disabled={isDisabled()}
              onClick={() => {
                !isUpload ? _onClose() : handleUploadImage();
              }}
              loading={loading}
            />
          </div>
        </div>
      </ModalAction>
    </>
  );
};
ImageActions.propTypes = {
  carrousel: PropTypes.any,
};
export default ImageActions;
